import { createBrowserHistory, History } from 'history';

let historyTemp: History | null = null;

// create history if it is missing
const history: History =
	historyTemp === null ? createBrowserHistory() : historyTemp;

export { history };
